import {
  TextTypeInput,
  TextTypeProps,
} from '@/components/GeneralInputs/TextTypeInput';
import {
  PaymentRequestForm,
  TransactionProperty,
} from '@/features/InvoiceReport/Edit/type';
import { memo } from 'react';

type Props<TFieldValues extends PaymentRequestForm> = Omit<
  TextTypeProps<TFieldValues>,
  'inputProps'
> & {
  property: TransactionProperty;
};

const InnerTextTypeCell = <TFieldValues extends PaymentRequestForm>({
  control,
  inputId,
  property,
  name,
  rules,
}: Props<TFieldValues>) => {
  return (
    <TextTypeInput<TFieldValues>
      control={control}
      inputId={inputId}
      name={name}
      placeholder={property.placeholder}
      rules={rules}
    />
  );
};
InnerTextTypeCell.displayName = 'InnerTextTypeCell';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const TextTypeCell = memo(InnerTextTypeCell) as typeof InnerTextTypeCell;
TextTypeCell.displayName = 'TextTypeCell';
